(() => {
  const root = document.querySelector('[data-coming-soon]');
  if (!root) return;
  const flash = root.querySelector('.cs__flash');
  const logo = root.querySelector('[data-glitch-logo]');

  const glitch = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    logo.animate([
      { transform: 'translate(0,0) skewX(0deg)' },
      { transform: 'translate(-4px,1px) skewX(-2deg)', offset: .2 },
      { transform: 'translate(5px,-1px) skewX(2deg)', offset: .42 },
      { transform: 'translate(-2px,0) skewX(-1deg)', offset: .62 },
      { transform: 'translate(0,0) skewX(0deg)' }
    ], { duration: 150, easing: 'steps(2,end)' });

    if (Math.random() > .55) {
      flash.animate([{opacity:0},{opacity:.06},{opacity:0}],{duration:80});
    }
  };

  const loop = () => {
    const delay = 1800 + Math.random() * 4200;
    setTimeout(() => { glitch(); loop(); }, delay);
  };
  loop();
})();
